import resolvePathname from 'resolve-pathname'

const ORIGIN = window.location.origin

export const isRelative = url => url.indexOf('..') !== -1 || url[0] === '.' || url[0] !== '/'

export const resolve = url => {
  const { href } = window.location
  url = resolvePathname(url, href[href.length - 1] !== '/' ? `${href}/` : href)
  if (url.indexOf('http') !== 0) {
    url = `${ORIGIN}${url}`
  }
  return url
}

const urlSegment = (name, val) => `${name}=${encodeURIComponent(val)}`
const arrayToUrl = (name, array) => array.map(val => urlSegment(`${name}[]`, val)).join('&')

export const objectToUrl = obj =>
  Object.entries(obj)
    .map(([key, val]) => {
      if (Array.isArray(val)) {
        return arrayToUrl(key, val)
      }
      return urlSegment(key, val)
    })
    .join('&')

// FIXME: case with #
export const urlToObject = (url = document.location.href) => {
  let query = url.split('?')
  query = query[query.length - 1]

  return decodeURIComponent(query)
    .split('&')
    .reduce((params, paramString) => {
      let [key, value] = paramString.split('=') // eslint-disable-line
      value = value || true
      // NOTE: case: same name params = array
      if (params[key]) {
        params[key] = Array.isArray(params[key]) ? [...params[key], value] : [params[key], value]
      } else {
        params[key] = value || true
      }
      return params
    }, {})
}

// Add ended slash for url
export const addSlash = url => {
  if (url[url.length - 1] !== '/') {
    url += '/'
  }
  return url
}
